import { render, staticRenderFns } from "./create-sitemap.vue?vue&type=template&id=2724ac9c&scoped=true&"
import script from "./create-sitemap.vue?vue&type=script&lang=ts&"
export * from "./create-sitemap.vue?vue&type=script&lang=ts&"
import style0 from "./create-sitemap.vue?vue&type=style&index=0&id=2724ac9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2724ac9c",
  null
  
)

component.options.__file = "create-sitemap.vue"
export default component.exports